import React, { Children } from 'react';
import classNames from 'classnames';
import styles from './DropDownBox.module.scss.js';

var DropDownBox = function (_a) {
    var expanded = _a.expanded, children = _a.children, className = _a.className;
    // eslint-disable-next-line react/no-array-index-key
    var getItems = function (ch) { return Children.map(ch, function (child, index) { return React.createElement("li", { key: index }, child); }); };
    var childWithProp = children ? getItems(children) : null;
    return (React.createElement("div", { className: classNames(styles.dropDownBox, expanded && styles.expanded, className) },
        React.createElement("ul", null, childWithProp)));
};

export { DropDownBox as default };
